/** @jsxImportSource @emotion/react */
import React from 'react'

interface StarIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: number
  color?: string
}

const StarIcon: React.FC<StarIconProps> = ({
  size,
  color,
  className,
  style,
  ...rest
}) => {
  return (
    <span className={`anticon ${className || ''}`} style={style} {...rest}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size ? `${size}px` : '1em'}
        height={size ? `${size}px` : '1em'}
        viewBox='0 -960 960 960'
        fill='none'
      >
        <path
          d='m233-120 65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z'
          fill={color || 'currentColor'}
        />
      </svg>
    </span>
  )
}

export default StarIcon
